import { Button } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { COBStep, getNextStepButtonText, getStepName } from "../ClientOnboarding.utils";
import { useCobConfig } from "../CobConfigContext";
import { StepPage } from "../../components/StepPage";
import VideoPlayer from "../../../components/VideoPlayer/VideoPlayer";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { videoUrl } from "../../../models/intro-video";
import styles from "./introVideoStepContainer.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const {
  IntroVideoStepTestIds
} = getTestIds();
const IntroVideoStep = _ref => {
  let {
    onDone,
    onBack
  } = _ref;
  const {
    MULTIPLE_LEGAL_TERMS_DOCUMENTS
  } = useFeatureFlags();
  const {
    relationship
  } = useCobConfig();
  const {
    introVideo
  } = relationship;
  const url = introVideo && videoUrl(introVideo);
  if (!url) {
    throw new Error('Intro Video does not have URL');
  }
  return /*#__PURE__*/_jsx(StepPage, {
    header: getStepName(COBStep.introVideo, relationship, Boolean(MULTIPLE_LEGAL_TERMS_DOCUMENTS)),
    dataTestId: IntroVideoStepTestIds.Root(),
    primaryBtn: /*#__PURE__*/_jsx(Button, {
      "data-testid": IntroVideoStepTestIds.PrimaryNextButton(),
      onClick: onDone,
      children: getNextStepButtonText(COBStep.introVideo, relationship, Boolean(MULTIPLE_LEGAL_TERMS_DOCUMENTS))
    }),
    onBackBtnClick: onBack,
    contentClassName: styles.introVideoStepContainer,
    children: /*#__PURE__*/_jsx("div", {
      "data-testid": IntroVideoStepTestIds.Video(),
      children: /*#__PURE__*/_jsx(VideoPlayer, {
        url: url,
        height: '100%'
      })
    })
  });
};
export default IntroVideoStep;